import api from 'config/api';

export const getVouchers = () => api.get('api/v1/vouchers');

export const voucherExchange = (accountId, voucherId) =>
  api.post(`api/v1/accounts/${accountId}/vouchers/${voucherId}/exchange`);
